// extracted by mini-css-extract-plugin
export default {"empty":"Empty_empty__3-Yhn","emptyText":"Empty_emptyText__1hsqU","emptyButton":"Empty_emptyButton__1IMfw"};